<template>
  <div>
    <section class="feature-area section-padding2" style="padding-top: 0px">
      <img src="../../static/assets/images/012.jpg" style="width: 100%;height: 500px;" mode="aspectFill">
    </section>
<!--    <header class="header-area single-page">-->
<!--      <div class="page-title text-center">-->
<!--        <div class="container">-->
<!--          <div class="row">-->
<!--            <div class="col-md-6 offset-md-3">-->
<!--              <h2>Comport</h2>-->
<!--              <p>There spirit beginning bearing the open at own every give appear in third you sawe two boys</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </header>-->
    <!-- Feature Area Starts -->
    <section class="feature-area section-padding2" style="padding-top: 40px">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>Book a table</h2>
<!--              <p>✉️ mountgambierbrewery@gmail.com</p>-->
              <p>📞 0466900048</p>
              <h2>Trading Hours</h2>
              <p>Thursday 3:00pm – 9:00pm</p>
              <p>Friday 12:00pm – 10:00pm</p>
              <p>Saturday 12:00pm – 10:00pm</p>
              <p>Sunday 12:00pm – 8:00pm</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Feature Area End -->
  </div>
</template>

<script>
  export default {}
</script>




// WEBPACK FOOTER //
// About.vue?39894060